import React from 'react';
import Slide from 'react-reveal/Slide';

// import {SectionTitle} from 'component/reuse/title';


const _features = [
  {
    "title": "Explore stock portfolios based on personal financial plans", 
    "description": "Easy visializations for you to make the right decision towards your fiancial goals", 
    "points": [
      "Portfolios that can generate monthly / weekly / even daily dividend income",
      "Explore if you want a high yield or high growth portfolio",
      "Explore your options to diversify your portfolio",
    ], 
    "img": {"src": "/static/images/features/01.svg", "alt": "", "size": "sm"},
    "bg": "rgba(255, 155, 113, 0.05)",
  },
  {
    "title": "Benefit from community knowledge", 
    "description": "People can build their own porfolio examples and share it to get feedback", 
    "points": [
      "You can view portfolio examples from others who wish to share their high level investment insights.",
      "Get notified on popular posts and portfolios so you never miss any update.",
    ], 
    "img": {"src": "/static/images/features/02.svg", "alt": "", "size": "sm"},
    "bg": "rgba(51, 181, 229, 0.05)",
  },
  {
    "title": "Stay on top of important changes!", 
    "description": "It's hard to keep track of dividend changes.", 
    "points": [
      "Periodic revaluation of your portfolio",
      "Narrow down the noise so you can focus on what's important to you",
      "Portfolio alignment to ensure synchronisation with goals",
    ], 
    "img": {"src": "/static/images/features/03.svg", "alt": "", "size": "sm"},
    "bg": "rgba(238, 213, 170, 0.05)",
  },
  {
    "title": "Build against our API", 
    "description": "We provide data in consumable API form for you to build your own workflows", 
    "points": [
      "Pipe the data any other service with a consumable API and slice and dice any way you want",
      "Backup data whenever you want to keep your own log",
      "Your call .. We can't wait to hear how you plan to consume this data!",
    ], 
    "img": {"src": "/static/images/features/04.svg", "alt": "", "size": "sm"},
    "bg": "rgba(213,197,255,0.05)",
  },
]

export default class Features extends React.Component {
  render (){
    return (
      <section id="subscribe" className="content-section flex-center my-3">
        <div className="container-fluid container" >
          {/* <SectionTitle first="What" second="you get" background="primary" /> */}

          <FeatureSection item={_features[0]} flip={true}/>
          <hr className=""/>
          <FeatureSection item={_features[1]} />
          <hr className=""/>
          <FeatureSection item={_features[2]} flip={true}/>
          <hr className=""/>
          <FeatureSection item={_features[3]} />
          
        </div>
      </section>
    )
  }
}


class FeatureSection extends React.Component {
  render (){
    const is_mobile = window.innerWidth < 1200;
    const {item, flip } = this.props;

    const img_width = {
      "sm": 4,
      "md": 6,
      "lg": 8,
    }[item.img.size]

    return (
      // <div className="my-5 py-1">
      <div className="my-2 row rounded" style={{backgroundColor: item.bg}}>
        {/* <div className="" style={{opacity: 1}}> */}

      {(flip)? '': <FeatureImg item={item} img_width={img_width} flip={flip} />}
        <div className={"d-flex align-items-center col-md-" + (12 - img_width) + ((is_mobile && flip)? ' order-2 my-3': ' my-5')}>
          <Slide bottom>
          <div className="flex-left text-black-3">
          <h2 className="my-3">{item.title}</h2>
          <h5 className="my-3">{item.description}</h5>
          <ul className="my-3">
            {item.points.map(function(point, idx){
              return(
                <li key={"_"+idx} className="my-2">{point}</li>
              )
            })}
          </ul>
          </div>
          </Slide>
        </div>
        {(flip)? <FeatureImg item={item} img_width={img_width} flip={flip} />: ""}

        {/* </div> */}
      </div>
      
      // </div>
    )
  }
}

function FeatureImg(props){
  const is_mobile = window.innerWidth < 1200;
  const {item, img_width, flip} = props;
  return(
    <div className={"align-self-center col-md-"+ (img_width) + ((is_mobile && flip)? ' order-1 my-3': ' my-5')}>
      <Slide left={!flip} right={flip}>
        <img className={"img img-fluid rounded p-3" + (is_mobile? ' mx-auto d-block': ' ')} src={item.img.src} alt={item.img.alt} />
      </Slide>
    </div>
  )
}